module.exports = __webpack_public_path__ + "img/collaborate_40.14ea6f49.jpg";